import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z' />
  </>,
  'Rollout'
)
